


















helpers = require('../../helpers.coffee')

view_model =
  props: ['filters']

  data: ->
    sort_filter: @extractFilter('s')
    sort_options: [
      { value: null, text: this.$t('contacts_group.filters.sortBy') }
      { value: { s: 'name asc' }, text: 'A-Z' }
      { value: { s: 'name desc' }, text: 'Z-A' }
      # { value: { s: 'contacts' }, text: 'Número de contatos' }
      # { value: { s: 'opportunities' }, text: 'Quantidade de conexões' }
    ]

    text_field_filter: null

  computed:
    filterParams: ->
      filter_params = {}

      if @sort_filter? &&  @sort_filter.s == 'name asc'
        IntercomCtrl.trackEvent('Base de contatos - Grupos - Ordenação A-Z')
      else if @sort_filter? && @sort_filter.s == 'name desc'
        IntercomCtrl.trackEvent('Base de contatos - Grupos - Ordenação Z-A')

      for filter in [@sort_filter]
        Object.assign(filter_params, filter) if filter
      filter_params['search_query'] = @text_field_filter if @text_field_filter
      filter_params

  methods:
    filter: ->
      @$emit('filter', @filterParams)
      IntercomCtrl.trackEvent('Filtrou a listagem de grupos') if @text_field_filter

exports.default = helpers.vue_include(view_model, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contact_groups/filters.vue